export const GRAPHQL_VARIABLES = {
  AuthToken: 'String!',
  globalPayAccountNumber: 'String!'
};

export const QUERY = `
 query getGlobalPayIframe{
   getGlobalPayIframe{
       AuthToken
       globalPayAccountNumber
       domain
       transType
       status
       ipAddress
       dump
   }
 }
 `;
